import { type SchedulerPro } from '@bryntum/schedulerpro'
import { storeLastVisibleTimeSpan } from './storeLastVisibleTimeSpan'
import { storeColumnsSubgridWidth } from './storeColumnsSubgridWidth'

export function persistSettings(scheduler?: SchedulerPro) {
  if (!scheduler) return
  storeColumnsSubgridWidth(scheduler)
  storeLastVisibleTimeSpan(scheduler)
}
